// extracted by mini-css-extract-plugin
module.exports = {"jobPosts":"jobPosts-module--jobPosts--3thz_","jobPosts__entry":"jobPosts-module--jobPosts__entry--2cGoc"};